import AdminNavbar from "./navbar";

export default function AdminPage(){
    return (
        <main className="w-full min-h-[100vh] bg-neutral-2">
            <AdminNavbar />
        </main>
    )
}